import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import GoogleAnalytics, {GTagProvider} from "./utils/GoogleAnalytics";
import Inspectlet from "./utils/Inspectlet";
import Hotjar from "./utils/Hotjar";
import { HelmetProvider } from "react-helmet-async";
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import * as FullStory from '@fullstory/browser';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
    Sentry.init({
        dsn: sentryDsn,
        integrations: [new BrowserTracing()],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}

if (process.env.REACT_APP_FULL_STORY_KEY) {
    FullStory.init({orgId: process.env.REACT_APP_FULL_STORY_KEY});
}

ReactDOM.render(
  <React.StrictMode>
      <HelmetProvider>
          <GoogleAnalytics />
          <Inspectlet />
          <Hotjar />
      </HelmetProvider>
      <GTagProvider><BrowserRouter>
          <App />
      </BrowserRouter></GTagProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
